// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"273":"bdee1cc2","289":"4b998709","383":"f85ba20a","492":"cfd5d4d2","574":"80b1fcf4","583":"8ba29b94","635":"5ca3ef84","641":"a7597c92","661":"20cb6c52","672":"37e41cd6","778":"63a94b8c","807":"69f3abea","828":"bb10f0b3","916":"9d90a28b","932":"fb9b722f"}[chunkId] + ".chunk.js";
};